import "./Headerinner.css";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "../../../contexts/AppContextProvider";
import useOnClickOutside from "@hooks/useOnClickOutside";
import { getNotificationsCount } from "../../../API/Notification";
import { logout } from "../../../API/Auth";
import NotificationsIcon from "../../../Assets/Images/Notification-bell.svg";
import storage from "@utils/storage";
import { useSocket } from "@utils/socket/socketContext";
import { getUser } from "../../../API/User";
import axios from "axios";
import envConfig from "../../../environment";
import { toast } from "react-toastify";
import { useGetWalletQuery } from "../../../API/Transaction";
import { defaultParams } from "@utils/global.constants";



interface ProtectedLayoutProps {
  children?: React.ReactNode;
  MenuOpen: () => void;
}

const Headerinner: React.FC<ProtectedLayoutProps> = ({ MenuOpen }) => {
  const { value } = useAppContext();
  const userImage = value?.user?.user?.profileImage || null;
  const [isOpen, setIsOpen] = useState(window.innerWidth < 800);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const imageUrl = profileImage?.startsWith("blob:")
    ? profileImage
    : `${envConfig.photoUrl}/public/profileImage/${profileImage}`;
  const navigate = useNavigate();
  const location = useLocation();
  const [stripeAccountId, setStripeAccountId] = useState<string | null>(null);
  const ref = useRef(null);
  const Id = storage.getUser();
  const user = Id.user;
  const [loading, setLoading] = useState(false);
  const { socket } = useSocket();
  const userId = Id.user.userId;
  const [params, setParams] = useState({
    ...defaultParams
  });

  const pageTitles: Record<string, string> = {
    "/app/dashboard": "",
    "/app/all-offers": "My Offers",
    "/app/open-offers": " My Offers",
    "/app/approved-offers": "My Offers",
    "/app/completed-offers": "My Offers",
    "/app/canceled-offers": "My Offers",
    "/app/in-review-offers": "My Offers",
    "/app/offer-applications": "Applications",
    "/app/submitted-applications": "Applications",
    "/app/rejected-applications": "Applications",
    "/app/approved-applications": "Applications",
    "/app/underReview-applications": "Applications",
    "/app/notification": "Notifications",
    "/app/wallet": "My Wallet",
    "/app/create-offer": "Create Offer",
    "/app/add-money": "My Wallet",
    "/app/withdraw-money": "My Wallet",
    "/app/profile": "My Profile",
    "/app/browse-offers": "Browse Offers",
    "/app/review-offer": "Review Offer",
    "/app/update-offer": "Edit Offer",
    "/app/view-applications": "View Application",
    "/app/view-transaction": "Transaction Summary",
  };

  const currentTitle = pageTitles[location.pathname] || <h3 className="m-0"><span>Welcome back,</span> {user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)} {user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1)}</h3>
    ;


  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        if (user?.userId) {
          const response = await getNotificationsCount(user.userId.toString());
          setNotificationsCount(response || 0);
        }
      } catch (error) {
        console.error("Failed to fetch notifications count:", error);
      }
    };

    fetchNotifications();

    if (!socket || !user?.userId) return;

    const handleNotificationCount = (data: { count: number }) => {
      setNotificationsCount(data.count);
    };

    socket.on("notification count", handleNotificationCount);

    // Optional: Request server to send current count
    socket.emit("get notification count", user.userId);

    return () => {
      socket.off("notification count", handleNotificationCount);
    };
  }, [socket, user?.userId]);


  useEffect(() => {
    setProfileImage(value?.user?.user?.profileImage);
  }, [value?.user?.user?.profileImage]);

  const handleClickOutside = () => {
    setIsOpen(false);
  };

  useOnClickOutside(ref, handleClickOutside);

  const handleLogout = () => {
    logout();
  };

  const navigateToNotification = () => {
    navigate("/app/notification");
  };

  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth < 800);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getUser()
      .then((res: any) => {
        const data = res.data.data.stripeAccountId;
        const profileImage = res.data.data.profileImage;
        setProfileImage(profileImage); // Update profile image state
        setStripeAccountId(data); // Save it in state
      })
      .catch((err) => {
        console.error("Failed to fetch user data", err);
      });
  }, []);
  // const handleOnboarding = async () => {
  //   try {
  //     const res = await axios.post(
  //       `${envConfig.apiUrl}/application/generate-onboarding-link`,
  //       {
  //         userId: user?.userId, // your logged-in user's UUID
  //         redirectPath: "/app/dashboard", // change to wherever you want to return after onboarding
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${storage.getToken()}`,
  //         },
  //       }
  //     );

  //     const onboardingLink = res?.data?.data;
  //     if (onboardingLink) {
  //       window.location.href = onboardingLink;
  //     } else {
  //       toast.error("Failed to retrieve onboarding link.");
  //     }
  //   } catch (err) {
  //     console.error("Onboarding error:", err);
  //     toast.error("Error generating Stripe onboarding link");
  //   }
  // };
  const handleOnboarding = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${envConfig.apiUrl}/application/generate-onboarding-link`,
        {
          userId: user?.userId,
          redirectPath: "/dashboard",
        },
        {
          headers: {
            Authorization: `Bearer ${storage.getToken()}`,
          },
        }
      );

      const onboardingLink = res?.data?.data;
      if (onboardingLink) {
        window.location.href = onboardingLink;
      } else {
        toast.error("Failed to retrieve onboarding link.");
      }
    } catch (err) {
      console.error("Onboarding error:", err);
      toast.error("Error generating Stripe onboarding link");
    } finally {
      setLoading(false);
    }
  };


  const {
    isLoading: isWalletLoading,
    isFetching: isWalletFetching,
    data: walletData,
    error: walletError,
    isError: isWalletError,
  } = useGetWalletQuery(userId, params);
  const walletAmount: number = walletData?.totalAmount || 0;

  return (
    <div className="header-inner-section d-flex align-items-center justify-content-between">
      <div className="heading d-flex align-items-center gap-3">
        <div className="hamburger" onClick={() => MenuOpen()}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40">
            <defs>
              <linearGradient id="myGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#197BBD" />
                <stop offset="100%" stopColor="#3391D0" />
              </linearGradient>
            </defs>
            <path
              d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm4 17H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2zm0-4H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2zm0-4H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2z"
              fill="url(#myGradient)"
            />
          </svg>
        </div>
        <h3 className="m-0">{currentTitle}</h3>
        {/* <h3 className="m-0"><span>Welcome back,</span> {user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)} {user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1)}</h3> */}
      </div>

      <div className="header-content d-flex align-items-center">
        {/* {stripeAccountId ? (
          <div style={{ width: "35px", borderRadius: "16px" }}>
            <span>
              <img src={righticon} alt="status-icon" className="img-fluid" />
            </span>
          </div>
        ) : (
          <div>
            <button
              onClick={handleOnboarding}
              className="create-offer-button-onboard-button"
              disabled={loading}
            >
              {loading ? (
                <span>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Loading...
                </span>
              ) : (
                "Complete Stripe Onboarding"
              )}
            </button>
          </div>
        )} */}
        <h6 className="doller">£ {walletAmount}</h6>
        <div
          className="notification-icon position-relative"
          onClick={navigateToNotification}
        >
          <div className="notification-img">
            <img src={NotificationsIcon} alt="Notifications" />
          </div>
          {notificationsCount > 0 && (
            <span className="notification-badge pt-0 position-absolute">{notificationsCount}</span>
          )}
        </div>

        <div
          onClick={() => navigate("/app/profile")}
          className="header-right-content d-flex align-items-center"
          ref={ref}
        >
          <div onClick={() => setIsOpen(!isOpen)} className="flex items-center justify-center w-12 h-12 bg-gray-200 rounded-full">
            {profileImage ? (
              <img
                src={`${envConfig.photoUrl}/public/profileImage/${profileImage}`}
                alt="Profile"
                className="name-initials-box rounded-full object-cover w-full h-full"
              />
            ) : (
              <div className="applicant-name-icon-inner-header d-flex align-items-center justify-content-center">
                <span className="text-capitalize">{user?.firstName?.[0] || "U"}</span>
                <span className="text-lowercase">{user?.lastName?.[0] || "N"}</span>
              </div>
            )}
          </div>


          <div className="lender-name" onClick={() => setIsOpen(!isOpen)}>
            <p>
              {user?.firstName
                ? user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)
                : "Andrew"}
            </p>
            <span className="d-block"> {user?.lastName
              ? user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1)
              : "Lender"}</span>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Headerinner;
